import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../translate';

@Component({
  selector: 'wego-success-popup',
  template: `
  <div bsModal #successModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ popupTitle }}</h4>
            </div>
            <div class="modal-body" style="word-wrap: break-word;">
                {{ popupMsg }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-green" (click)="Confirm($event)">{{ 'LblOK' |  translate }}</button>
            </div>
        </div>
    </div>
  </div>`,
})

export class SuccessPopupComponent implements OnInit, OnDestroy {
  _popupTitle: string = this.translate.instant('LblSuccess');
  _popupMsg: string = this.translate.instant('LblRecordSavedSuccess');

  @ViewChild('successModal') public successModal: ModalDirective;

  @Input()
  set popupMsg(popupMsg: string) {
    this._popupMsg = (popupMsg && popupMsg.trim()) || this.translate.instant('LblRecordSavedSuccess');
  }
  get popupMsg() { return this._popupMsg; }

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblSuccess');
  }
  get popupTitle() { return this._popupTitle; }

  @Output() onConfirm = new EventEmitter();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  public show(autoConfirm: boolean = true) {
    this.successModal.show();
    if (autoConfirm) {
      setTimeout(() => this.Confirm(null), 3000);
    }
  }

  public hide() {
    this.successModal.hide();
  }

  private Confirm($event: any) {
    this.hide();
    this.onConfirm.emit($event);
  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/popup/success-popup.component.ts